import tablesort from "tablesort";

module.exports = Promise.all([
    import("utils/router"),
    import("tap-confirmation-dialogs"),
    import("bootstrap/js/modal"),
]).then(deps => {
    let [Routing, confirmationDialogs] = deps;

    $(function() {
        setupKbModals();
        setupCollapseChevrons();
        confirmationDialogs.setup();
        setupPanelFilters();
        setupSelectize();
        setupMergeTagDropdowns();

        $(".tablesorter").each(function() {
            tablesort(this);
        });

        $(document).on("click", ".click-sibling", function() {
            $(this)
                .next()
                .click();
        });
    });

    /**
     * KB Modals
     */
    function setupKbModals() {
        $(document).on("click", ".kb-modal-trigger", function() {
            var old = Routing.getBaseUrl();
            Routing.setBaseUrl("https://tapfiliate.com");
            var url = Routing.generate("tap_knowledgebase_frontend_article_show", { slug: $(this).data("slug") });
            Routing.setBaseUrl(old);

            window.open(url);
        });
    }

    /**
     * Collapse chevrons
     */
    function setupCollapseChevrons() {
        $("[id^=collapse]").on("show.bs.collapse", function() {
            $(this)
                .parent()
                .find(".tapicon-chevron-down")
                .removeClass("tapicon-chevron-down")
                .addClass("tapicon-chevron-up");
        });
        $("[id^=collapse]").on("hidden.bs.collapse", function() {
            $(this)
                .parent()
                .find(".tapicon-chevron-up")
                .removeClass("tapicon-chevron-up")
                .addClass("tapicon-chevron-down");
        });
    }

    /**
     * Panel filters
     */
    function setupPanelFilters() {
        $(".panel-filter-table-show-all").on("click", function() {
            $(".panel-filter-table")
                .find("[data-" + "recurrer-id" + "]")
                .each(function() {
                    $(this).show();
                    $(".filtered-text-holder").fadeOut();
                    $(".panel-filter-table-show-all").attr("disabled", true);
                });
        });
    }

    $(document).on("focus", "[data-no-focus-yet]", function() {
        $(this).removeAttr("data-no-focus-yet");
        $(this).removeData("no-focus-yet");
    });

    function setupMergeTagDropdowns() {
        let insertAtCursor = require("utils/insert-at-cursor");

        $(".merge-tag-option").on("click", function() {
            insertAtCursor(
                $(this)
                    .parents(".input-group")
                    .find("input, textarea")[0],
                $(this).data("value"),
            );
        });
    }

    function setupSelectize() {
        $("[data-selectize]").each(function() {
            var self = this;
            $(this).selectize({
                delimiter: ",",
                persist: false,
                plugins: ["remove_button"],
                create: function(input) {
                    return {
                        value: input,
                        text: input,
                    };
                },
                onItemAdd: function(value, item) {
                    $vHolder = $(self).siblings(".v-holder");
                    var curItems = $vHolder.find('input[type="hidden"]').length;
                    var name = $(self).data("name");
                    var input =
                        '<input type="hidden" value="' + value + '" name="' + name + "[" + curItems + "]" + '"/>';
                    $(self)
                        .siblings(".v-holder")
                        .append(input);
                },
                onItemRemove: function(value, i) {
                    $(self)
                        .siblings(".v-holder")
                        .children('input[value="' + i.data("value") + '"]')
                        .remove();
                },
            });
        });
    }
});
